module.exports = __webpack_public_path__ + "media/images/icon-arrow-left-ee9bf19f1b137822973670316053eb18.svg";